import { GET_PREONBOARDING_STEP, CLEAR_PREONBOARDING_STEP } from '../../constants/pre-onboarding/pre-onboarding.js';

const initialState = {
    preOnboardingStep: null,
}
export const GetPreonboardingReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PREONBOARDING_STEP:
            return {
                ...state,
                preOnboardingStep: action.payload,
            }
        case CLEAR_PREONBOARDING_STEP:
            return {
                preOnboardingStep: null
            }
        default:
            return state
    }
}  